import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useAdminAuth } from './hooks/useAdminAuth';
import AdminShell from './components/layout/AdminShell';

function AuthGate() {
  const { authenticated, connectionStatus } = useAdminAuth();

  if (connectionStatus === 'connecting') {
    return (
      <div className="admin-auth-screen">
        <div className="win-panel admin-auth-panel">
          <h2>Sweepr Admin</h2>
          <p>Connecting to control-plane...</p>
        </div>
      </div>
    );
  }

  if (connectionStatus === 'error') {
    return (
      <div className="admin-auth-screen">
        <div className="win-panel admin-auth-panel">
          <h2>Connection Error</h2>
          <p>Could not connect to the control-plane server.</p>
          <button className="win-button" style={{ marginTop: 8 }} onClick={() => window.location.reload()}>
            Retry
          </button>
        </div>
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div className="admin-auth-screen">
        <div className="win-panel admin-auth-panel">
          <h2>Access Denied</h2>
          <p>You are not authorized to access the admin dashboard.</p>
        </div>
      </div>
    );
  }

  return <AdminShell />;
}

function App() {
  return (
    <BrowserRouter>
      <AuthGate />
    </BrowserRouter>
  );
}

export default App;
